import { render, staticRenderFns } from "./TheoryExamDetails.vue?vue&type=template&id=c5916bde"
import script from "./TheoryExamDetails.vue?vue&type=script&lang=ts"
export * from "./TheoryExamDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports